/*
* Project: BookingEngine
* Module: components/icons/RadioSelectIcon.js
* vim:ft=javascript.jsx:
*/
import React from 'react';

const selectedMark = (
  <g className="theme-path" fillRule="evenodd">
    <path
      d="M10,6 L10,6 C12.209139,6 14,7.790861 14,10 L14,10 C14,12.209139 12.209139,14 10,14 L10,14 C7.790861,
            14 6,12.209139 6,10 L6,10 C6,7.790861 7.790861,6 10,6 Z"
    />
  </g>
);

const RadioSelectIcon = ({ isSelected }) => (
  <svg className="svg-icon radio-select-icon" width="20px" height="20px" viewBox="0 0 20 20" version="1.1"
       xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
    <g className="grey-path">
      <path
        d="M10,0 C15.5228475,-1.01453063e-15 20,4.4771525 20,10 C20,15.5228475 15.5228475,20 10,
            20 C4.4771525,20 6.76353751e-16,15.5228475 0,10 C-6.76353751e-16,4.4771525 4.4771525,1.01453063e-15 10,
            0 Z M10,2 C5.581722,2 2,5.581722 2,10 C2,14.418278 5.581722,18 10,18 C14.418278,18 18,14.418278 18,10 C18,
            5.581722 14.418278,2 10,2 Z"
      />
    </g>
    {isSelected && selectedMark}
  </svg>
);

export default RadioSelectIcon;
